
import { useAuth } from './AuthContext';
import Sidebar from '../app/Sidebar';
import { useLocation, useParams } from 'react-router-dom';

export default function SidebarWrapper({ children }: { children: React.ReactNode }) {
   const { user } = useAuth();
   const pathname = useLocation().pathname || '';

   // Force isolation for independent entities like CRM Viewers
   const isDisconnectedEntity = pathname.includes('/services/crm/');

   if (!user || isDisconnectedEntity) return <main>{children}</main>; 

   return (
     <>
       <Sidebar />
       <main className="main-content">
         {children}
       </main>
     </>
   );
}
